// extracted by mini-css-extract-plugin
export default {"iconWrapper":"iconWrapper_0V9P","fontawesome":"fontawesome_La6D","bg":"bg_XoFz"};